<template>
  <div class="tc-layout">
    <div class="tc-container">
      <MenuNavigation v-if="showMenu" class="tc-top-nav" />
      <div class="tc-content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import MenuNavigation from "../../components/MenuNavigationMobile.vue";

export default {
  components: {
    MenuNavigation,
  },
  computed: {
    showMenu() {
      return this.$route.path !== '/timecard/login' && this.$store.getters.isAuthenticated;
    },
  },
};
</script>

<style scoped>
.tc-layout {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8f5e9 100%);
}

.tc-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 16px;
}

.tc-top-nav {
  margin-bottom: 16px;
}

.tc-content {
  min-height: 70vh;
}
</style>
